import _ from 'lodash';
import { getField } from 'vuex-map-fields';
import PlaylistService from '@/services/PlaylistService';

import { PLAYPOSIT_API_ENDPOINTS } from '@Constants';

export default {
  activeLMBURL: (state) => {
    if (state.user.userType === 'student')
      return `${PlaylistService.baseURL}designer/?bulb_id=${state.activeLMB.bulbId}&section_id=${state.sectionId}&token=${state.activeLMB.teacherToken}&playlist_launch=true`;
    return 'https://bunny.playposit.com/images/lmb.jpg';
  },
  activeModuleItemAttempt: (state) =>
    _.find(
      state.playlistAttempt.moduleItemAttempts,
      (mia) => mia.moduleItem.itemId === state.activeModuleItemId,
    ),
  activePlaylistVideoURL: (state) => {
    if (!_.isEmpty(state.activeResourceLinkURL)) return '';
    /**
     * I would normally deconstruct these values from the `state` object, however, not all these values are guaranteed to be defined,
     * thus, initializing them this way.
     */
    const [
      userToken,
      playlistId,
      bulbId,
      moduleId,
      sectionId,
      nsf,
      scoreThreshold,
      resourceLinkId,
      lmsConsumerVersion,
      lti13Launch,
      lmsIssuer,
    ] = [
      state?.userToken,
      state?.playlistId,
      state?.activePlaylistVideo?.bulbId,
      state?.activePlaylistVideo?.moduleId,
      state?.sectionId,
      state?.nsf,
      state?.activePlaylistVideo?.scoreThreshold,
      state?.resourceLinkId,
      state?.lmsConsumerVersion,
      state?.lti13Launch,
      state?.lmsIssuer,
    ];
    if (state.user.userType === 'student') {
      return PLAYPOSIT_API_ENDPOINTS.playerStudentRedirect({
        baseURL: PlaylistService.baseURL,
        sectionId,
        bulbId,
        userToken,
        nsf,
        playlistId,
        moduleId,
        scoreThreshold,
        resourceLinkId,
        lmsConsumerVersion,
        lti13Launch,
        lmsIssuer,
      });
    }
    return PLAYPOSIT_API_ENDPOINTS.playerInstructorRedirect({
      baseURL: PlaylistService.baseURL,
      sectionId,
      bulbId,
      userToken,
      scoreThreshold,
      resourceLinkId,
      lmsConsumerVersion,
      lti13Launch,
    });
  },
  fullName: (state) => `${state.profile.firstName} ${state.profile.lastName}`,
  getField,
  hasPlaylistCertificateAccess: (state) => state.hasPlaylistCertificateAccess,
  hasSchoolCertificateAccess: (state) => state.hasSchoolCertificateAccess,
  isMobileIOS: () => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    const ios = /iphone|ipod|ipad/.test(userAgent);
    // Testing for the platform type and maxTouchPoints is duct tape to detect ipads on iOS 13+)
    if (
      ios ||
      (window.navigator.platform === 'MacIntel' &&
        window.navigator.maxTouchPoints > 1)
    )
      return true;
    return false;
  },
  isMobile: (state, getters) => getters.isMobileIOS || /android/i.test(window.navigator.userAgent),
  queryParams: (state) => state.queryParams,
  restrictPlaylistAccess: (state) => state.user.teacherContainerRole > 2,
  snackbar: (state) => state.snackbar,
  userAccountType: (state) => _.get(state, 'profile.hostingLog.type', false),
  unUsedElements: (state) => state.unUsedElements,
  hasHidePlaylistSaveAndExitButtonFeature: (state) => {
    // eslint-disable-line
    /*
     * Chick-fil-a && UFL want to hide the `Save & Exit` button for links they distribute outside of an LMS.
     * They currently do not use an LMSbut will in the future.
     */
    return (
      _.get(state, 'playlist.school.permissionKeys', []).includes(
        'hidePlaylistSaveAndExitButton',
      ) && !_.has(state, 'playlist.isLti')
    );
  },
  lmsConsumerVersion: (state) => {
    if (state?.lti13Launch)
      return state?.playlist?.lti13CustomResourceLinkInfo?.lti13ResourceLink
        ?.lti13Context?.lti13Consumer?.productFamilyCode;
    return state?.playlist?.lti2CustomResourceLinkInfo?.lti2ResourceLink
      ?.lti2Context?.lti2Consumer?.consumerVersion;
  },
  lmsEnabledGrading: (state) => {
    if (state?.lti13Launch)
      return state?.playlist?.lti13CustomResourceLinkInfo?.enableGrading
        ?.data?.[0];
    return state?.playlist?.lti2CustomResourceLinkInfo?.enableGrading;
  },
};
